module.exports = __webpack_public_path__ + "40dc6e7731eb68b4a740fdca7ebef974.png";